import React from 'react'
import PageHeader from '../components/shared/pageHeader/PageHeader'
import LeadsHeader from '../components/shared/header/MailTemplateHeader'
import LeadssTable from '../components/leads/MailTemplates'
import Footer from '../components/shared/Footer'

const MailTemplates = () => {
    return (
        <>
            <PageHeader>
                <LeadsHeader />
            </PageHeader>
            <div className='main-content'>
                <div className='row'>
                    <LeadssTable />
                </div>
            </div>
            
        </>
    )
}

export default MailTemplates